/* eslint-disable @typescript-eslint/no-unused-vars */
import { Navigate, useLocation } from "react-router-dom";
import { useFontDesk } from "../context/frontDeskContext";

const PublicRoute = ({ children }: any) => {
  const { pathname } = useLocation();

  const { isAuthenticated, initialRoute } = useFontDesk();

  if (isAuthenticated === null) {
    return <Navigate to={`${pathname}`} />;
  }

  if (isAuthenticated) {
    return <Navigate to={initialRoute ?? "/"} />;
  }

  return children;
};

export default PublicRoute;
